import React from "react";
import MenuItem from "@mui/material/MenuItem";
import { useNavigate } from "react-router-dom";
import { clearAuthSession } from "../../utils/loginRemember";

interface LogoutButtonProps {
  handleClose: () => void;
}

export default function LogoutButton({ handleClose }: LogoutButtonProps) {
  const navigate = useNavigate();

  const handleLogout = () => {
    clearAuthSession();
    handleClose();
    navigate("/");
  };

  return <MenuItem onClick={handleLogout}>Cerrar sesion</MenuItem>;
}
